import React, { useState, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import InfoIcon from '@8x8/oxygen-icon/novo/InfoCircleIcon'
import Tooltip from '@8x8/oxygen-tooltip'

import Modal from '~/components/common/modal'
import { translate, Translate } from '~/core/translate'
import { FlexCentered } from '../common/containers'
import ViewJoinOptions from '~/components/view-join-options'
import JoinCustomRoom from '~/components/join-custom-room'

const TooltipTarget = styled.div`
  width: 18px;
  height: 18px;
  display: inline-block;
`

const StartMeetingHint = styled(FlexCentered)`
  cursor: pointer;
  color: ${props => props.theme.colorListItemIcon};
  place-content: center;
  margin-top: 16px;
  font-size: ${({ theme }) => theme._neo.label01.fontSize};
  padding: 10px;
  box-sizing: border-box;
  border-radius: 3px 3px 0 0;
  background-color: ${props => props.isActive ? props.theme.backgroundViewJoinOptions : 'transparent'};
  ${props => props.isActive && `
    border-bottom: 1px solid ${props.theme.colorDelimiter}
  `};
  svg {
    fill: ${props => props.theme.colorListItemIcon};
    margin-top: 4px;
    margin-left: 8px;
  }
`

const JoinCustomRoomDialog = () => {
  const [showJoinHelp, setShowJoinHelp] = useState(false)
  const theme = useContext(ThemeContext)

  return (
    <Modal title={translate('join_or_start_meeting')}>
      <Translate>enter_meeting_name_or_link</Translate>
      <JoinCustomRoom joinButtonLabel={translate('join_meeting')} />
      <StartMeetingHint isActive={showJoinHelp} onClick={() => setShowJoinHelp(!showJoinHelp)}>
        <Translate>how_to_start_meeting</Translate>
        <Tooltip
          delay={300}
          title={translate('view_join_options')}
          orientation='bottom'
          showOn='hover'
        >
          <TooltipTarget>
            <InfoIcon color={theme.colorSecondary} />
          </TooltipTarget>
        </Tooltip>
      </StartMeetingHint>
      {showJoinHelp && <ViewJoinOptions />}
    </Modal>
  )
}

export default JoinCustomRoomDialog
